import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatErr } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, obj = user
  const [config, setConfig] = useState({ locations: [], complaint_types: [], priorities: [], statuses: [], roles: [] });

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("np_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("np_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/config");
        setConfig(data);
      } catch { /* ignore */ }
      await loadMe();
    })();
  }, [loadMe]);

  async function login(email, password) {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("np_token", data.access_token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatErr(e.response?.data?.detail) || e.message };
    }
  }

  async function register(payload) {
    try {
      const { data } = await api.post("/auth/register", payload);
      localStorage.setItem("np_token", data.access_token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatErr(e.response?.data?.detail) || e.message };
    }
  }

  function logout() {
    localStorage.removeItem("np_token");
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, setUser, config, login, register, logout, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
